import {priority} from '@priority-software/priority-proto-api/lib';
import {getValueByColName} from '../../_shared/GWTBridge/invoke/formTable';
import {COL_NAME_FORM_DESCRIPTION, COL_NAME_FORM_TITLE} from './consts';
import {ColumnTypeToCodeMap, getBaseColumnType} from './types/column';
import {IQueryFilter, ISearchCondition, typeTomodulsMapping} from './types/filters';
import {ISearchField} from '../../common/searchType';

export interface SelectedFields {
    name: string;
    title: string;
}
export const serializeRecords = (records: any[] = []): SelectedFields[] =>
    records.map(record => ({
        name: record.Fields[0]?.Value?.Str,
        title: record.Fields[1]?.Value?.Str
    }));

export const serializeFields = (
    selectedFields: SelectedFields[] = [],
    columns: priority.netitems.form.IColumn[] = []
): ISearchField[] =>
    columns.reduce((acc: ISearchField[], column) => {
        const {Name, ID, Title, Type, Zoom, SearchAll, Decimal, Width, DefaultValue, Relcol} =
            column;
        const selctedField = selectedFields.find(fld => fld.name === Name);
        if (selctedField) {
            const isZoom = Zoom === priority.netitems.form.ZoomType.SelectZoom && !Relcol;
            acc.push({
                columnID: ID,
                columnName: Name,
                title: selctedField.title || Title,
                type: Type,
                isZoom,
                isChoose: isZoom && !SearchAll,
                searchAll: SearchAll,
                decimal: Decimal,
                maxLength: Number(Width),
                code: ColumnTypeToCodeMap[Type],
                defaultValue: DefaultValue
            });
        }
        return acc;
    }, []);

export const buildSearchFilters = (
    filters: IQueryFilter[],
    columns: ISearchField[]
): ISearchCondition[] =>
    filters.reduce((acc: ISearchCondition[], filter) => {
        const column = columns.find(col => col.columnID === filter.Condition[0]?.ColumnID);

        if (column) {
            const {title, type, columnName} = column;
            const baseType = getBaseColumnType(type);
            const typeModule = typeTomodulsMapping[baseType];
            const searchFilter = typeModule.serialize(filter.Condition);

            acc.push({
                ...searchFilter,
                columnName,
                title: title,
                type: getBaseColumnType(type),
                isdesc: filter.isdesc,
                isSort: filter.isSort,
                origType: type
            });
        }

        return acc;
    }, []);

export const buildQueryFilters = (
    filters: ISearchCondition[],
    IgnoreCase: boolean
): IQueryFilter[] =>
    filters.map(filter => {
        const {type, isSort, isdesc} = filter;

        const typeModule = typeTomodulsMapping[type];
        const Condition = typeModule
            .buildQuery(filter)
            .map(condition => ({...condition, IgnoreCase}));

        return {Condition, isSort, isdesc};
    });

export const getFormtitle = () => {
    const decription = getValueByColName(COL_NAME_FORM_DESCRIPTION);
    if (decription) return decription;
    return getValueByColName(COL_NAME_FORM_TITLE);
};
